<script>
import Navbar from "@/components/navbar";
import Layout from "@/layouts/main";
import appConfig from "@/app.config";
import axios from 'axios';
import AOS from 'aos';
import "aos/dist/aos.css";

export default {
  components: {
    Layout,
    Navbar,
  },
  data() {
    return {
      appConfig: appConfig,
      login: {
        idx: 0,
        level: 0,
        nick: "",
        isLogin: false,
      },
      editPage: false, // 관리자 편집 기능 사용 유무
      map: null,
      geocoder: null,
      baseInfo: {},
      hasScrolledToContact: false, // 한 번만 스크롤했는지 추적
      isUserScrolling: false, // 사용자가 수동으로 스크롤 중인지 추적
      scrollTimeout: null, // 스크롤 타이머
      handleScroll: null, // 스크롤 핸들러 함수
      introData: [],
    }
  },
  computed: {
  },
  watch: {
    '$route'(to, from) {
      // 라우트 변경 시 해시가 있으면 스크롤 (다른 페이지에서 온 경우에만)
      if (to.hash === '#contact' && from.path !== to.path) {
        this.hasScrolledToContact = false; // 새로운 페이지 진입 시 플래그 리셋
        this.$nextTick(() => {
          // 페이지 렌더링과 맵 로드 대기 후 스크롤
          setTimeout(() => {
            this.scrollToContact();
          }, 600);
        });
      }
    }
  },
  metaInfo() {
    return {
      title: '센터소개 | 대구여성인권센터',
      meta: [
        {
          name: 'description',
          content: '대구여성인권센터를 소개합니다. 성매매없는 세상을 희망하고, 상상하고, 행동합니다.'
        },
        {
          property: 'og:title',
          content: '센터소개 | 대구여성인권센터'
        },
        {
          property: 'og:description',
          content: '대구여성인권센터를 소개합니다. 성매매없는 세상을 희망하고, 상상하고, 행동합니다.'
        },
        {
          property: 'og:url',
          content: window.location.href
        },
        {
          name: 'twitter:title',
          content: '센터소개 | 대구여성인권센터'
        },
        {
          name: 'twitter:description',
          content: '대구여성인권센터를 소개합니다. 성매매없는 세상을 희망하고, 상상하고, 행동합니다.'
        }
      ]
    }
  },
  mounted() {
    // AOS 초기화
    AOS.init({
      duration: 800,
      easing: 'ease-in-out',
      once: true
    });
    
    // 사용자 스크롤 이벤트 감지
    this.handleScroll = () => {
      this.isUserScrolling = true;
      if (this.scrollTimeout) {
        clearTimeout(this.scrollTimeout);
      }
      this.scrollTimeout = setTimeout(() => {
        this.isUserScrolling = false;
      }, 150);
    };
    window.addEventListener('scroll', this.handleScroll, { passive: true });
    
    // 해시가 있으면 스크롤 (한 번만)
    this.$nextTick(() => {
      if (this.$route.hash === '#contact' && !this.hasScrolledToContact) {
        // 페이지 렌더링과 맵 로드 대기 후 스크롤
        setTimeout(() => {
          this.scrollToContact();
        }, 600);
      }
    });
  },
  beforeDestroy() {
    // 이벤트 리스너 정리
    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }
  },
  created() {
    this.first()
    this.getWebSiteInfoBase()
    this.getMenuIntro()
  },
  methods: {
    // 처음에 실행되는 부분
    async first() {
      // 로그인 사용자 정보
      let getLocalStorage = JSON.parse(localStorage.getItem('user'))
      if (getLocalStorage) {
        this.login.idx = getLocalStorage.idx
        this.login.nick = getLocalStorage.nick
        this.login.level = getLocalStorage.level
        this.token = getLocalStorage.token
      }
      // prerender 중에는 지도 초기화 건너뛰기
      if (typeof window !== 'undefined' && window.__PRERENDER_INJECTED) {
        return;
      }
      
      if (this.baseInfo.address !== '') {
        // DOM 이 완전히 렌더링된 뒤에만 지도 초기화 시도
        this.$nextTick(() => {
          if (!window.kakao || !window.kakao.maps) {
            // ip주소 변경되면 안되나? 카카오API에서 사이트 도메인 집어넣는 부분 확인
            // https://developers.kakao.com/console/app/927124/config/platform
            // script 태그 객체 생성
            const script = document.createElement("script");
            // src 속성을 추가
            // &autoload=false api로드한 후 맵을 그리는 함수가 실행되게 구현
            script.src = "//dapi.kakao.com/v2/maps/sdk.js?appkey=7b0ef77a6f9e5464aca1d29ecc4f1bbd&libraries=services&autoload=false";
            /* global kakao */
            script.addEventListener("load", () => {
              if (window.kakao && window.kakao.maps) {
                kakao.maps.load(() => {
                  // kakao 스크립트까지 로드된 뒤에 Vue 인스턴스 컨텍스트로 initMap 실행
                  this.initMap();
                });
              }
            });
            // 스크립트 로딩 실패 처리
            script.addEventListener("error", () => {
              console.warn('Kakao Maps SDK 로딩 실패 (prerender 중일 수 있음)');
            });
            document.head.appendChild(script); // document의 head에 script 추가
          } else {
            this.initMap();
          }
        });
      }
    },
    initMap() {
      // prerender 중이거나 kakao.maps가 없으면 건너뛰기
      if (typeof window === 'undefined' || window.__PRERENDER_INJECTED || !window.kakao || !window.kakao.maps) {
        return;
      }
      
      const container = document.getElementById("map");
      // 간헐적으로 DOM이 준비되지 않은 경우를 방어
      if (!container) {
        return;
      }
      
      try {
        const options = {
          center: new kakao.maps.LatLng(128.600466095176, 35.8556931789011, 16),
          level: 2,
        };
        const map = new kakao.maps.Map(container, options);
        const geocoder = new kakao.maps.services.Geocoder();
        geocoder.addressSearch(this.baseInfo.address, function(result, status) {
          // 정상적으로 검색이 완료됐으면 
          if (status === kakao.maps.services.Status.OK) {
            var coords = new kakao.maps.LatLng(result[0].y, result[0].x);
            // 결과값으로 받은 위치를 마커로 표시합니다
            var marker = new kakao.maps.Marker({
              map: map,
              position: coords
            });
            // 인포윈도우로 장소에 대한 설명을 표시합니다
            var infowindow = new kakao.maps.InfoWindow({
              content: '<div style="background-color:#7952B3;color:#ffffff;font-weight:700;width:150px;text-align:center;font-size:11px;padding:17px;">대구여성인권센터</div>'
            });
            infowindow.open(map, marker);
            // 지도의 중심을 결과값으로 받은 위치로 이동시킵니다
            map.setCenter(coords);
          } else {
            console.log(status)
          }
        });
      } catch (error) {
        console.warn('지도 초기화 실패 (prerender 중일 수 있음):', error);
      }
    },
    // 홈페이지 기본정보
    getWebSiteInfoBase() {
      this.baseInfo = this.$store.getters.getWebSiteInfoBase
    },
    // contact로 스크롤 (한 번만 실행)
    scrollToContact() {
      // 이미 스크롤했거나 사용자가 수동으로 스크롤 중이면 실행하지 않음
      if (this.hasScrolledToContact || this.isUserScrolling) {
        return;
      }
      // ref를 우선 사용하고, 없으면 id로 찾기
      const element = this.$refs.contact || document.getElementById('contact');
      
      if (element) {
        // 요소가 완전히 렌더링될 때까지 대기
        this.$nextTick(() => {
          const rect = element.getBoundingClientRect();
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const elementTop = rect.top + scrollTop - 100; // 네비게이션 바 공간 확보
          
          // 플래그 설정 (한 번만 스크롤)
          this.hasScrolledToContact = true;
          
          window.scrollTo({
            top: elementTop,
            behavior: 'smooth'
          });
        });
      }
    },
    introEdit() {
      this.editPage = true
      // br 태그를 \n 태그로 변경 해주자
      this.introData.text1 = this.introData.text1.replace(/<br\s*\/?>/gi, '\n')
      this.introData.text2 = this.introData.text2.replace(/<br\s*\/?>/gi, '\n')
      this.introData.text3 = this.introData.text3.replace(/<br\s*\/?>/gi, '\n')
      this.introData.text4 = this.introData.text4.replace(/<br\s*\/?>/gi, '\n')
      this.introData.text5 = this.introData.text5.replace(/<br\s*\/?>/gi, '\n')
    },
    introEditCancelButton() {
      this.editPage = false
      // \n 태그를 br 태그로 변경 해주자
      this.introData.text1 = this.introData.text1.replace(/\n/gi, '<br />')
      this.introData.text2 = this.introData.text2.replace(/\n/gi, '<br />')
      this.introData.text3 = this.introData.text3.replace(/\n/gi, '<br />')
      this.introData.text4 = this.introData.text4.replace(/\n/gi, '<br />')
      this.introData.text5 = this.introData.text5.replace(/\n/gi, '<br />')
    },
    // 센터소개 저장
    introSaveButton(workKey) {
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_center_intro_edit_save',
        data: {
          "workKey": workKey,
          "value": this.introData[workKey].replace(/\n/gi, '<br />'),
        },
      })
      .then((response) => {
        this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
      })
      .catch((error) => {
        this.$notify({ type: 'danger', duration:2000, 'title': '실패', text: error.response.data.message})
      })
      .finally(() => {
        this.getMenuIntro()
        this.editPage = false
      })
    },
    // 센터소개 이미지 저장
    introSaveImage1(file) {
      let formData = new FormData()
      formData.append('token', this.token)
      formData.append('workKey', 'image1')
      formData.append('files', file)
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_center_intro_image_save',
        data: formData,
        headers: {
          'Content-Type': 'multipart/form-data'
        }
      })
      .then((response) => {
        this.$notify({ type: 'success', duration:2000, 'title': '성공', text: response.data.message})
      })
      .catch((error) => {
        this.$notify({ type: 'danger', duration:2000, 'title': '실패', text: error.response.data.message})
      })
      .finally(() => {
        this.getMenuIntro()
        this.editPage = false
      })
    },
    // 백엔드에서 센터소개 가져오기
    getMenuIntro() {
      axios({
        method: 'POST',
        url: appConfig.fastapi + '/board/jy_center_intro_list',
        data: {
          "work": "intro",
        },
      })
      .then((response) => {
        if (response.data.introData) {
          this.introData = response.data.introData
        } else {
          // prerender 중에는 알림 표시하지 않음
          if (typeof window !== 'undefined' && !window.__PRERENDER_INJECTED) {
            this.$notify({ type: 'success', duration:2000, 'title': '실패', text: response.data.message})
          }
        }
      })
      .catch((error) => {
        // prerender 중 401 에러는 정상적인 것으로 간주
        if (error.response && error.response.status === 401) {
          // prerender 중이므로 기본값 유지
          console.log('API call failed during prerender (expected):', error.response.status);
        } else {
          console.log('API call error:', error);
        }
        // 기본값 설정 (빈 객체 대신 기본 구조 유지)
        if (!this.introData || Object.keys(this.introData).length === 0) {
          this.introData = {
            text1: '',
            text2: '',
            text3: '',
            text4: '',
            text5: '',
            image1: '',
            image1_time: ''
          };
        }
      })
      .finally(() => {
        // prerender 완료 이벤트 발생 (데이터 로드 여부와 관계없이)
        this.$nextTick(() => {
          if (typeof document !== 'undefined') {
            document.dispatchEvent(new Event('render-event'));
          }
        });
      })
    }
  },
}
</script>

<template>
  <Layout>
    <!-- 네비게이션 글자 하얗게는 :nav-light="true" -->
    <Navbar :nav-light="true" />

    <section class="bg-half-2 navwave d-table w-100">
      <div class="animation-effect-8"><i class="mdi mdi-cloud-outline effect-icon-1 text-primary"></i></div>
      <div class="animation-effect-9"><i class="mdi mdi-rocket effect-icon-1 text-light"></i></div>
      <div class="bread-overlay-2 opacity-5"></div>
      <div class="container">
        <div class="row justify-content-center">
          <div class="col-lg-12 text-center">
            <div class="page-next-level">
              <div class="title text-white title-dark">
                <h3>센터소개</h3>
                <h4>대구여성인권센터를 소개합니다</h4>
              </div>
              <div class="page-next">
                <nav aria-label="breadcrumb" class="d-inline-block">
                  <ul class="breadcrumb bg-white rounded shadow mb-0">
                    <li class="breadcrumb-item">
                      <router-link to="/">홈</router-link>
                    </li>
                    <li class="breadcrumb-item "><a href="#">센터</a></li>
                    <li class="breadcrumb-item active" aria-current="page">센터소개</li>
                  </ul>
                </nav>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <!-- 둥글게 처리 -->
    
    <div class="position-relative">
      <div class="shape overflow-hidden text-white">
        <svg viewBox="0 0 2880 48" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 48H1437.5H2880V0H2160C1442.5 52 720 0 720 0H0V48Z" fill="currentColor"></path>
        </svg>
      </div>
    </div>
    
    <section class="section bg-light mt-60 mb-0">
      <div class="container " id="contact">

        <!-- 관리자라면 -->
        <div v-if="login.level > 97 && !editPage" class="mb-2">
          <b-button @click="introEdit()" class="btn btn-block btn-md btn-soft-blue">
            <i class="mdi mdi-book-edit mr-1"></i>관리자 편집하기
          </b-button>
        </div>
        <!-- 관리자 편집 페이지 -->
        <div v-if="login.level > 97 && editPage" class="mb-2">
          <b-button @click="introEditCancelButton()" class="btn btn-block btn-md btn-primary">
            <i class="mdi mdi-close mr-1"></i>편집 닫기
          </b-button>
        </div>

        <div class="row">
          <div class="col-lg-12 col-md-12">
            
            <div class="row">
              <div class="col-lg-4 mb-4">
                <div class="card bg-soft-primary">
                  <div class="card-body">
                    <!-- text1 -->
                    <div v-if="editPage == false && introData.text1" class="h2" v-html="introData.text1"></div>
                    <div v-if="editPage == true" class="h2">
                      <b-form-textarea v-model="introData.text1" rows="6"  class="form-control form-control-xl" placeholder="5줄 권장합니다." maxlength="50" />
                      <b-button @click="introSaveButton('text1')" class="btn btn-blue btn-block">저장하기</b-button>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-lg-8 mb-4 my-3">
                <!-- text2 -->
                <div v-if="editPage == false && introData.text2" class="h3" v-html="introData.text2"></div>
                <div v-if="editPage == true" class="h3">
                  <b-form-textarea v-model="introData.text2" rows="3" class="form-control form-control-lg " placeholder="2줄 권장합니다." maxlength="50" />
                  <b-button @click="introSaveButton('text2')" class="btn btn-blue btn-block">저장하기</b-button>
                </div>
                
                <div data-aos="fade-down" class="text-muted mt-2">
                  <!-- text3 -->
                  <div v-if="editPage == false && introData.text3" class="font-size-17" v-html="introData.text3"></div>
                  <div v-if="editPage == true" class="font-size-17">
                    <b-form-textarea v-model="introData.text3" rows="7" class="form-control form-control-md " placeholder="6줄 권장합니다." maxlength="400" />
                    <b-button @click="introSaveButton('text3')" class="btn btn-blue btn-block">저장하기</b-button>
                  </div>
                </div>
              </div>
              <div data-aos="fade-up" class="col-lg-12 mb-4">
                  <div class="mt-4">
                  <!-- image1 -->
                  <div class="p-2 bg-soft-blue text-center">
                    <!-- 이미지 src 뒤에 image1_time 붙여서 캐싱 문제 해결하자 -->
                    <div v-if="editPage == true" class="text-center">
                      <!-- 이미지 첨부는 jpg, jpeg, png 파일만 가능하고 파일 한개만 첨부 -->
                      <b-form-file
                        class="form-control form-control-md"
                        placeholder="이미지를 선택해주세요."
                        accept="image/jpg, image/jpeg, image/png"
                        :multiple="false"
                        @change="introSaveImage1($event.target.files[0])"
                      />
                    </div>
                    <!-- 이미지 출력 -->
                    <div v-else>
                      <img v-if="editPage == false && introData.image1" :src="introData.image1 + '?image1_time=' + introData.image1_time" class="w-100" />
                    </div>
                  </div>
                </div>
                <div class="card mt-4">
                  <div class="card-body">
                    <span class="font-size-15">
                      <!-- text4 -->
                      <div v-if="editPage == false && introData.text4" class="h5 text-center" v-html="introData.text4"></div>
                      <div v-if="editPage == true" class="h5 text-center">
                        <b-form-textarea v-model="introData.text4" rows="1" class="form-control form-control-md" style="text-align: center;" placeholder="아래 본문의 제목을 입력해주세요." maxlength="100" />
                        <b-button @click="introSaveButton('text4')" class="btn btn-blue btn-block">저장하기</b-button>
                      </div>
                      <!-- text5 -->
                      <div v-if="editPage == false && introData.text5" class="font-size-17" v-html="introData.text5"></div>
                      <div v-if="editPage == true" class="h7">
                        <b-form-textarea v-model="introData.text5" rows="21" class="form-control form-control-md" placeholder="20줄 이상도 가능합니다. (최대 2000자)" maxlength="2000" />
                        <b-button @click="introSaveButton('text5')" class="btn btn-blue btn-block">저장하기</b-button>
                      </div>
                    </span>
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>
      </div>
      
      <!-- 찾아오시는 길 -->
      <div class="container mt-4" >
        <div class="row">
          <div class="col-lg-4 col-md-6 pt-2">
            <div class="card">
              <div class="card-body py-5">
                <div v-if="editPage == true" class="p-2 bg-danger text-white text-center h6 rounded">
                  아래 부분들은 관리자페이지 > 최고관리기능 > 기본 설정 에서 편집가능합니다.
                </div>
                <h3 class="card-title">찾아오시는 길</h3>
                <div class="custom-form mt-3">
                  <div class="row">
                    <div class="col-md-12">
                      <div class="form-group">
                        <label>
                          <span v-if="this.baseInfo.longName" class="text-primary text-bold">{{ this.baseInfo.longName }}</span>
                          <span class="text-danger">*</span>
                        </label>
                        <div class="">
                          <span v-if="this.baseInfo.address">{{ this.baseInfo.address }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group font-size-15">
                        <label>
                          <span v-if="this.baseInfo.office1Name" class="text-bold">{{ this.baseInfo.office1Name }}</span>
                          <span class="text-danger"> *</span>
                        </label>
                        <div class="">
                          <span v-if="this.baseInfo.office1Number" class="">{{ this.baseInfo.office1Number }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group font-size-15">
                        <label>
                          <span v-if="this.baseInfo.office2Name" class="text-bold">{{ this.baseInfo.office2Name }}</span>
                          <span class="text-danger"> *</span>
                        </label>
                        <div class="">
                          <span v-if="this.baseInfo.office2Number" class="">{{ this.baseInfo.office2Number }}</span>
                        </div>
                      </div>
                    </div>
                    <div class="col-md-12">
                      <div class="form-group font-size-15">
                        <label>
                          <span v-if="this.baseInfo.office1Number" class="text-bold">팩스</span>
                          <span class="text-danger"> *</span>
                        </label>
                        <div class="">
                          <span v-if="this.baseInfo.office1Number" class="">{{ this.baseInfo.fax1Number }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!--end col-->

          <div class="col-lg-8 col-md-6 pl-md-3 pr-md-3 pt-2">
            <div ref="contact" id="contact" class="card">
              <div class="map map-height-two map-gray">
                <div id="map" style="width:100%;height:500px"></div>
              </div>
            </div>
            <div class="bg-soft-blue p-2 rounded border border-2 border-primary text-center text-primary h5 mt-2">
              {{ this.baseInfo.address }}
            </div>
            <div class="bg-soft-secondary p-1 rounded border border-2 border-secondary text-center font-weight-bold text-secondary font-size-13 mt-2">
              지도를 움직이거나 이동, 확대, 축소 가능합니다.
            </div>
          </div>
          <!--end col-->
        </div>
      </div>
    </section>
    
  </Layout>
</template>
